module.exports = __webpack_public_path__ + "img/report_candidate.7008e4b9.svg";